import script from "./AuditSettingsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditSettingsForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QOptionGroup,QBtnToggle});
